import React, { Component, Fragment } from "react";
import { Modal, Form, Input, Checkbox } from "antd";
import { inject, observer } from "mobx-react";
import co from "co";
import { RouterState } from "mobx-state-router";

const FormItem = Form.Item;

@Form.create({
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class DuplicateCampaignForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	getValues = () => {
		return {
			name: this.props.form.getFieldValue("name"),
			useSameAccounts: this.props.form.getFieldValue("useSameAccounts")
		};
	};

	render() {
		return (
			<Fragment>
				<FormItem
					labelCol={{ span: 5 }}
					wrapperCol={{ span: 15 }}
					label="Name"
				>
					{this.props.form.getFieldDecorator("name", {
						rules: [
							{
								required: true,
								message: "Please enter campaign name"
							}
						]
					})(<Input placeholder="My great SEO campaign" />)}
				</FormItem>
				<FormItem wrapperCol={{ offset: 5, span: 15 }} label="">
					{this.props.form.getFieldDecorator("useSameAccounts", {
						valuePropName: "checked"
					})(<Checkbox>Use same accounts</Checkbox>)}
				</FormItem>
			</Fragment>
		);
	}
}

@inject("rootStore")
@observer
class DuplicateCampaignDialog extends Component {
	mapPropsToFields = () => {
		const {
			rootStore: { campaignsStore }
		} = this.props;

		const ui = campaignsStore.ui;

		if (ui.duplicatedCampaign == null) {
			//Means that we are adding a new campaign
			return {
				name: Form.createFormField({
					value: undefined
				})
			};
		} else {
			return {
				name: Form.createFormField({
					value: ui.duplicatedCampaign.name
				}),
				useSameAccounts: Form.createFormField({
					value: true
				})
			};
		}
	};

	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	goToDuplicateCampaignRoute = name => {
		const {
			rootStore: { campaignsStore, routerStore }
		} = this.props;

		const ui = campaignsStore.ui;

		co(
			function*() {
				const response = yield this.validateForm();
				if (response != null) return;
				const formValues = this.internalForm.getValues();

				const toState = new RouterState(
					"duplicatecampaign",
					{
						cid: ui.duplicatedCampaign.id
					},
					{
						campaignName: formValues.name,
						useSameAccounts: formValues.useSameAccounts
					}
				);

				routerStore.goTo(toState);
			}.bind(this)
		);
	};

	hideDialog = () => {
		const {
			rootStore: { campaignsStore }
		} = this.props;

		campaignsStore.hideDuplicateCampaignDialog();
	};

	render() {
		const {
			rootStore: { campaignsStore }
		} = this.props;

		const ui = campaignsStore.ui;

		let title = "Duplicate Campaign";

		return (
			<Modal
				visible={ui.duplicateCampaignDialogVisible}
				title={title}
				okText="Duplicate"
				onCancel={this.hideDialog}
				onOk={this.goToDuplicateCampaignRoute}
			>
				<DuplicateCampaignForm
					fields={this.mapPropsToFields()}
					wrappedComponentRef={internalForm => {
						this.internalForm = internalForm;
					}}
				/>
			</Modal>
		);
	}
}

export default DuplicateCampaignDialog;
